import { Platform } from 'types/general.types';

export const getPaddingLeft = (platform?: Platform) => {
  if (platform === 'darwin') {
    return 70;
  }
  return 0;
};

export const getPaddingRight = (isWeb: boolean, platform?: Platform) => {
  if (isWeb) {
    return 0;
  }
  if (platform !== 'darwin') {
    return 140;
  }
  return 0;
};

export const transitions = {
  headerElement: {
    exit: { duration: 0.2 },
    enter: { duration: 0.3 },
  },
};
